export default {
  tableActionText: 'Press "Add" to add a new element',
  title: 'Fixed assets Data and Financial expenses to offices',
  info: 'In this screen you can add fixed assets data and financial expenses to offices for each line.',
  question: 'Check the box if you want to fill in fixed assets data or financial expenses to offices',
  check: 'I want to fill in fixed assets data or financial expenses to offices.',
  headers: {
    officeId: 'Office Id',
    fileNumber: 'Fixed asset sheet',
    appraisalAmount: 'Appraisal amount',
    invoiceAmount: 'Invoice amount'
  },
  inmobilizedData: {
    title: 'Fixed asset data'
  },
  officeFinancialExpenses: {
    title: 'Financial expenses to offices'
  }
}
